// Pricing English translations
export const pricingEn = {
  'add.fee.structure': 'Add Fee Structure',
  'add.load.unload.fee': 'Add Load/Unload Fee',
  'add.load.unload.fee.button': 'Add Load/Unload Fee',
  'add.price': 'Add Price',
  'add.rm2.fee': 'Add RM2 Fee',
  'add.toll.fee': 'Add Toll Fee',
  'adding.price': 'Adding Price',
  'additional.fees': 'Additional Fees',
  'base.price': 'Base Price',
  'delete.rm2.fee.confirm': 'Are you sure you want to delete this RM2 fee?',
  'districts.override.this.price': 'districts override this price',
  'document.upload': 'Document Upload',
  'document.upload.processing': 'Document Upload & Processing',
  'download': 'Download',
  'edit.fee.structure': 'Edit Fee Structure',
  'edit.load.unload.fee': 'Edit Load/Unload Fee',
  'edit.rm2.fee': 'Edit RM2 Fee',
  'edit.toll.fee': 'Edit Toll Fee',
  'enter.fee.amount': 'Enter fee amount',
  'enter.price.amount': 'Enter price amount',
  'error.creating.rm2.fee': 'Error creating RM2 fee',
  'error.deleting.rm2.fee': 'Error deleting RM2 fee',
  'error.updating.rm2.fee': 'Error updating RM2 fee',
  'extra.toll.fee.1': 'Extra Toll Fee 1',
  'extra.toll.fee.2': 'Extra Toll Fee 2',
  'failed.to.fetch.rm2.fees': 'Failed to fetch RM2 fees',
  'failed.to.load.image': 'Failed to load image',
  'failed.to.load.map': 'Failed to load map',
  'failed.to.load.positions': 'Failed to load vehicle positions',
  'fee.amount': 'Fee Amount',
  'fee.must.be.greater.than.zero': 'Fee must be greater than or equal to 0',
  'fee.structure.history': 'Fee Structure History',
  'fee.structure.management': 'Fee Management',
  'fee.type': 'Fee Type',
  'load.unload.fee': 'Load/Unload Fee',
  'load.unload.fee.management': 'Load/Unload Fee Management',
  'loading': 'Loading',
  'loading.fee': 'Loading Fee',
  'manage.fee.structure': 'Manage Fee',
  'new.fee': 'New Fee',
  'new.price': 'New Price',
  'no.price.history.available': 'No price history available',
  'no.prices.found': 'No prices found',
  'old.fee': 'Old Fee',
  'old.price': 'Old Price',
  'optional.notes.about.rm2.fee': 'Optional notes about this RM2 fee',
  'optional.reason.for.price.change': 'Optional reason for price change',
  'overrides.province.price': 'Overrides province price',
  'please.enter.fee.amount': 'Please enter the fee amount',
  'please.enter.valid.price': 'Please enter valid price per liter',
  'price': 'Price',
  'price.change': 'Price Change',
  'price.per.km': 'Price per KM',
  'price.per.liter': 'Price/L',
  'pricing': 'Pricing',
  'reason.for.creating.updating.rm2.fee': 'Reason for creating/updating this RM2 fee',
  'rm2': 'RM2',
  'rm2.fee': 'RM2 Fee',
  'rm2.fee.created.successfully': 'RM2 fee created successfully',
  'rm2.fee.deleted.successfully': 'RM2 fee deleted successfully',
  'rm2.fee.history': 'RM2 Fee History',
  'rm2.fee.management': 'RM2 Fee Management',
  'rm2.fee.updated.successfully': 'RM2 fee updated successfully',
  'system.fee.management': 'System Fee Management',
  'toll.fee': 'Toll Fee',
  'toll.fee.management': 'Toll Fee Management',
  'total.fee': 'Total Fee',
  'update.price': 'Update Price',
  'upload.more.documents': 'Upload More Documents',
  'upload.new.to.replace': 'Upload a new file below to replace the current image',
  'upload.pdf.or.image': 'Upload PDF or image files. The system will automatically recognize fuel receipts and delivery notes.',
  'upload.process': 'Upload & Process',
  'upload.receipt.file': 'Upload Receipt File',
  'uploading': 'Uploading...',
};
